import { Product } from "app/components/class/product/product";
import { Category } from "app/components/class/category/category";

export class ChangeSumm {

    product: Product;
    productsLen: number;
    categori: Array<Category>;
  //  actualBudgets: number;
    constructor(product, productsLen, categori) {
        this.product = product;
        this.productsLen = productsLen;
        this.categori = categori;
      //  this.actualBudgets = 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/add-campaign/class/ChangeSumm.ts